import { AxleFieldNames } from '@contracts/order/fields/AxleInformationFields';
import { AxleFormName as ContractsAxleFormName } from '@contracts/order/fields/AxleInformationFields';
import { AxleType } from '@contracts/order/valueNormalizers/AxleType';
import { SuspensionType } from '@contracts/order/valueNormalizers/SuspensionType';
import { TireSize } from '@contracts/order/valueNormalizers/TireSize';
import {
  BooleanField,
  DropdownField,
  PositiveIntegerField,
  StringField,
  ZeroOrPositiveFloatField,
} from '@src/permitField/PermitFields';
import * as yup from 'yup';

export class AxleIdField extends StringField {
  public static fieldName = AxleFieldNames.AxleId;
}

export class AxleTypeField extends DropdownField {
  public static fieldName = AxleFieldNames.AxleType;
  public static options = AxleType;
  public static validator = yup
    .string()
    .oneOf([...AxleTypeField.options, ''])
    .required();
}

export class TireSizeField extends DropdownField {
  public static fieldName = AxleFieldNames.TireSize;
  public static options = TireSize;
  public static validator = yup
    .string()
    .oneOf([...TireSizeField.options, ''])
    .required();
}

export class SuspensionTypeField extends DropdownField {
  public static fieldName = AxleFieldNames.SuspensionType;
  public static options = SuspensionType;
  public static validator = yup
    .string()
    .oneOf([...SuspensionTypeField.options, ''])
    .required();
}

export class AxleGroupField extends DropdownField {
  public static fieldName = AxleFieldNames.AxleGroup;
  public static options = Array.from({ length: 9 }, (_, i) =>
    (i + 1).toString(),
  );
  public static validator = yup
    .string()
    .oneOf([...AxleGroupField.options, ''])
    .required();
}

export class AxleWeightField extends ZeroOrPositiveFloatField {
  public static fieldName = AxleFieldNames.AxleWeight;
}

export class AxleSpacingField {
  public static fieldName = AxleFieldNames.AxleSpacing;
  public static validator = yup
    .number()
    .typeError('isNumber')
    .min(0)
    .required();
}

export class TireCountField extends PositiveIntegerField {
  public static fieldName = AxleFieldNames.TireCount;
  public static validator = yup
    .number()
    .typeError('isNumber')
    .min(0, 'isPositive')
    .integer()
    .required();
}

export class TireRatingField extends ZeroOrPositiveFloatField {
  public static fieldName = AxleFieldNames.TireRating;
}

export class AxleCapacityField extends ZeroOrPositiveFloatField {
  public static fieldName = AxleFieldNames.AxleCapacity;
}

export class AxleWidthField extends ZeroOrPositiveFloatField {
  public static fieldName = AxleFieldNames.AxleWidth;
}

export class IsSteeringAxleField extends BooleanField {
  public static fieldName = AxleFieldNames.IsSteeringAxle;
}

export const AxleFieldsType = [
  AxleWeightField.fieldName,
  AxleWidthField.fieldName,
  AxleSpacingField.fieldName,
  TireCountField.fieldName,
  TireRatingField.fieldName,
  TireSizeField.fieldName,
  AxleCapacityField.fieldName,
  AxleTypeField.fieldName,
  SuspensionTypeField.fieldName,
  AxleGroupField.fieldName,
  IsSteeringAxleField.fieldName,
] as const;

export const AxleFormName = ContractsAxleFormName;

export const SumOfAxleWeightName = 'sumOfAxleWeight';
export const AxleOverallWeightName = 'axleOverallWeight';
